<div
  class="modal fade"
  [class.show]="mostrarModal"  
  id="modalBoasVindas"
  tabindex="-1"
  aria-labelledby="modalBoasVindasLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title fs-5" id="exampleModalLabel">Bem-vindo ao Atalho! 🚀</h3>
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="color: #0070C0;">        
        <p class="text-center" *ngIf="clienteEhPrePago">
          Para começar a usar a plataforma, é necessário adicionar créditos à sua conta. Escolha o valor desejado e a
          forma de pagamento para desbloquear todas as funcionalidades do Atalho.
          Vamos nessa?
        </p>
        <p class="text-center" *ngIf="!clienteEhPrePago">
          Sua conta já está ativa e pronta para uso! Explore todas as funcionalidades da plataforma e aproveite ao máximo sua experiência.
          Qualquer dúvida, estamos por aqui
        </p>
      </div>
      <div class="modal-footer">
        <button *ngIf="clienteEhPrePago" type="button" class="btn btn-primary" (click)="navegarParaRecarga($event)">Confirmar</button>
        <button *ngIf="!clienteEhPrePago" type="button" class="btn btn-primary" (click)="fecharModal()">Confirmar</button>
      </div>
    </div>
  </div>
</div>